import PropTypes from "prop-types";
import React, { useState } from "react";
import "../../style/SortAlbum.css";
// images
import sortDownImg from "/images/sort-down.svg";
import sortDownAltImg from "/images/sort-down-alt.svg";
const CROISSANT = false;
const DECROISSANT = true;

const SortAlbum = ({ onChange, disableGroupSorting = false }) => {
  const [selectedSortingType, setSelectedSortingType] = useState("title");
  const [selectedSortingOrder, setSelectedSortingOrder] = useState(CROISSANT);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedSortingType(value);
    onChange({type: value, order: selectedSortingOrder});
  };

  const handleChangeOrder = (event) => {
    if (selectedSortingOrder === CROISSANT) {
      setSelectedSortingOrder(DECROISSANT);
      onChange({type: selectedSortingType, order: DECROISSANT});
    } else {
      setSelectedSortingOrder(CROISSANT);
      onChange({type: selectedSortingType, order: CROISSANT});
    }
  };

  return (
    <div className="sort-group">
      <label htmlFor="sort-select" className="sort-label">Trier par :</label>
      <select id="sort-select" onChange={handleChange} className="sort-select">
        <option value="title">Titre (A-Z)</option>
        {disableGroupSorting || <option value="group">Par groupe</option>}
        <option value="date">Date de sortie</option>
      </select>
      <button className="sort-order" onClick={handleChangeOrder}>
        <img src={selectedSortingOrder ? sortDownImg : sortDownAltImg} alt={selectedSortingOrder ? "Tri par ordre croissant" : "Trie par ordre décroissant"} />
      </button>
    </div>
  );
};

SortAlbum.propTypes = {
  onChange: PropTypes.func.isRequired, // Pour notifier le parent du tri choisi
};

export default SortAlbum;
